<template>
  <div class="fm_result_details">
    <el-dialog title="Story & Feedback Details"
               :visible.sync="showDialogBox"
               :width="dialogBoxWidth"
               lock-scroll
    >
      <hr />
      <grid :rwd="{numResultSeletorBreaks:'stack'}">
        <grid-item size="12/24" :rwd="{numResultSeletorBreaks: '1/1'}" style="text-align: left" class="details_row">
          <div class="result_testimonial_rating">
            <el-rate
                v-model="resultObject.fm_stars"
                disabled
                show-score
                text-color="#ff9900"
                :score-template="ratingText()">
            </el-rate>
          </div>
        </grid-item>
        <grid-item size="12/24" :rwd="{numResultSeletorBreaks: '1/1'}" style="text-align: right">
          <b>By:&nbsp;&nbsp;</b> <span class="fm_person">{{resultObject.fm_person_name}}</span> <br />
          <b>On:</b>&nbsp;&nbsp;<span class="fm_date">{{resultObject.fm_date}}</span><br />
          <b>Channel:&nbsp;&nbsp;</b>{{ resultObject.fm_channel}}  <a :href="resultObject.fm_channel_url" target="_blank">(Visit)</a>
        </grid-item>
      </grid>
      <hr />
      <el-row :gutter="20" class="details_row">
        <el-col :span="24"><h4 v-html="resultObject.fm_title">{{ resultObject.fm_title }}</h4></el-col>
      </el-row>

      <grid :rwd="{numResultSeletorBreaks: 'stack-reverse'}" class="details_row">
        <grid-item size="6/20" :rwd="{numResultSeletorBreaks: '1/1'}">
          <div v-html="resultObject.fm_thumbnail_html">{{ resultObject.fm_thumbnail_html}}</div>
        </grid-item>
        <grid-item size="18/20" :rwd="{numResultSeletorBreaks: '1/1'}">
          <div v-html="resultObject.fm_content_cleaned">
            {{ resultObject.fm_content_cleaned }}
          </div>
        </grid-item>
      </grid>

      <hr />
      <el-row :gutter="20" class="details_row" v-if="resultObject.fm_screenshot_html != ''">
        <el-col>
          <h6>Story/Feedback Screenshot:</h6><br />
          <div v-html="resultObject.fm_screenshot_html">
            {{resultObject.fm_screenshot_html}}
          </div>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    props: ['dialogFormVisible', 'resultObject'],
    data() {
      return {
      }
    },
    methods: {
      ratingText(){
        return this.resultObject.fm_stars + ' Star Rating';
      },
      dialogBoxWidth(){ //not working with grid - only computed value delivers results but does not adjust on screen size change.
        //define the default value
        let boxWidth = '80%';
        const viewPortWidth = window.innerWidth;

        //change the default based on the window size
        if(viewPortWidth > 980){
            boxWidth = '40%';
        } else {
            boxWidth = '80%';
        }
        return boxWidth;
      }
    },
    computed: {
      dialogBoxWidth(){
        //define the default value
        let boxWidth = '80%';
        const viewPortWidth = window.innerWidth;

        //change the default based on the window size
        if(viewPortWidth < 430){
            boxWidth = '95%';
        } else if (viewPortWidth > 430 && viewPortWidth < 920){
            boxWidth = '80%';
        } else if (viewPortWidth > 920 && viewPortWidth < 1800){
            boxWidth = '60%';
        } else {
            boxWidth = '40%';
        }
        return boxWidth;
      },
      showDialogBox: {
        get(){
          return this.dialogFormVisible;
        },
        set(value){
          this.$emit('boxWasClosed', false);
        }
      }
    }

  }
</script>

<style lang="scss">
.details_row {
  margin-bottom: 10px;
}
</style>